import React, { Component } from 'react';
import Big from 'big.js';
import _ from 'underscore';
import styled from 'styled-components';

const Styled = styled.span`
    --font-size-base: 1rem;
    --font-size-cents: 0.75rem;

    font-weight: 500;

    .small {
        --font-size-base: 0.85rem;
        --font-size-cents: 0.65rem;
    }

    .large {
        --font-size-base: 1.375rem;
        --font-size-cents: 0.9rem;
    }

    .amount__base {
        font-size: var(--font-size-base);
    }

    .suffix,
    .currency,
    .amount__cents {
        font-size: var(--font-size-cents);
    }

    .suffix {
        opacity: 0.7;
    }
`;

/**
 * Format the number with commas, decimal points and currency
 *
 * Props
 * - amount (required if no priceLevels prop) --- INT                       --- single amount
 *                                            -- (priority if both 'amount' and 'priceLevels' present)
 * - priceLevels (required if no amount prop) --- [{unit_price,min_qty}...] --- customer price levels
 * - currency (string)
 * - dp (int, default to 2)
 * - dp2 (int, extended decimal points)
 * - fontSizeLevel (String: {'large', 'normal', 'small'}) -- for styling
 **/
class FormatNumber extends Component {
    static defaultProps = {
        fontSizeLevel: 'normal',
    };

    // eg: 1.23 ==> ['1', '23']
    splitAmountString = amount => amount.toString().split('.');

    getStyledAmount = amount => {
        const {
            currency,
            fontSizeLevel,
        } = this.props;

        const [base, cents] = this.splitAmountString(amount);
        // return <p>{base}{`.${cents}`}</p>
        return (
            <>
                <span className={`currency ${fontSizeLevel}`}>{currency}</span>
                <span className={`amount__base ${fontSizeLevel}`}>{base}</span>
                <span className={`amount__cents ${fontSizeLevel}`}>{`.${cents}`}</span>
            </>
        );
    };

    formatNumber = (amount, dp, dp2) => {
        const bigAmount = new Big(amount);

        // Extended decimal points, eg: 2,4
        let endDp = dp;
        let bigAmountRounded = bigAmount.round(endDp);
        if (dp2 !== undefined) { // Extended
            for (let i = dp + 1; i <= dp2; i += 1) { // 3,4
                if (bigAmountRounded.cmp(bigAmount.round(i)) !== 0) {
                    endDp = i;
                    bigAmountRounded = bigAmount.round(i);
                }
            }
        }

        // adds comma to every thousands eg: 2000000.00 => 2,000,000.00
        return bigAmount.toFixed(endDp).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    };

    render() {
        const {
            currency,
            amount,
            priceLevels,
            simpleRangeMode,
            dp,
            dp2,
            suffix,
            id,
            onChange,
            fontSizeLevel, // for styled-component -- 'large', 'normal'
            ...restProps
        } = this.props;

        if (!priceLevels) {
            return (amount === null || amount === undefined || amount === '') ? '-' : (
                <Styled {...restProps}>
                    {this.getStyledAmount(this.formatNumber(amount, dp || 2, dp2))}
                    &nbsp;
                    <span className={`suffix ${fontSizeLevel}`}>{suffix}</span>
                </Styled>
            );
        }

        let amountMin, amountMax;
        if (priceLevels.length) {
            if (priceLevels.length === 1) {
                return (
                    <Styled {...restProps}>
                        {this.getStyledAmount(this.formatNumber(priceLevels[0].unit_price, dp || 2, dp2))}
                        &nbsp;
                        <span className={`suffix ${fontSizeLevel}`}>{suffix}</span>
                    </Styled>
                );
            }

            if (priceLevels.length > 1) {
                amountMin = _.min(priceLevels, p => p.unit_price).unit_price;
                amountMax = _.max(priceLevels, p => p.unit_price).unit_price;

                return (simpleRangeMode) ? (
                    <Styled {...restProps}>
                        <div className="ellipsis-div">
                            <span className={`currency ${fontSizeLevel}`}>From</span>
                            &nbsp;
                            {this.getStyledAmount(this.formatNumber(amountMin, dp || 2, dp2))}
                        </div>
                    </Styled>
                )
                    : (
                        <Styled {...restProps}>
                            <span className="ellipsis-div">
                                {this.getStyledAmount(this.formatNumber(amountMin, dp || 2, dp2))}
                             &nbsp;-&nbsp;
                                {this.getStyledAmount(this.formatNumber(amountMax, dp || 2, dp2))}
                            </span>

                            &nbsp;
                            <span className={`suffix ${fontSizeLevel}`}>{suffix}</span>

                        </Styled>
                    );
            }
        }
        return null;

        // else {
        //     amountMin = amountMax = amount[0]?.unit_price || 0;
        //     // No amount
        //     if (amountMin === null || amountMin === undefined || amountMin === '')
        //         return '-';

        //     return (
        // <Styled {...restProps}>
        //     {this.getStyledAmount(this.formatNumber(amountMin, dp || 2, dp2))}
        //     <span className={`suffix ${fontSizeLevel}`}>{suffix}</span>
        // </Styled>
        //     );
        // }
    }
}

export default FormatNumber;
